import SettingsComponent from "../../components/shared/SettingsComponent"
import { SidebarLayout } from "../../components/Sidebar"

const Settings = () => {
    return (
        <SidebarLayout currentPath="/settings">
            <SettingsComponent />
        </SidebarLayout>
    )
}

export default Settings
